import PropTypes from "prop-types"
import kebabCase from "lodash.kebabcase"
import Badge from "components/atoms/Badge"
import Button from "components/buttons/Button"
import Checkmark from "images/checkmark.svg"
import useTranslations from "hooks/useTranslations"

import { numberWithCommas } from "utils/helpers"

const ListItem = ({ item }) => {
  return (
    <li className="flex items-start">
      <div className="shrink-0">
        {/* <div className="absolute w-6 h-6 bg-teal-500 rounded-full" /> */}
        <Checkmark className="h-6 w-6 transform text-teal-300" />
      </div>
      <p className="ml-3 text-base leading-6 text-zinc-100">{item}</p>
    </li>
  )
}

const PricingTier = ({
  name,
  duration,
  description,
  features,
  partnerPrice,
  fullPrice,
  partner,
  onClick,
}) => {
  const { orderModalButton, currency, normalPrice } = useTranslations()

  const price = partner ? partnerPrice : fullPrice

  return (
    <div className="flex grow flex-col overflow-hidden rounded-lg shadow-lg">
      <div className="flex flex-col bg-kkm-green px-6 py-8 sm:p-10 sm:pb-6">
        <div>{name ? <Badge>{name}</Badge> : null}</div>
        <div className="mt-4 flex items-baseline text-5xl font-extrabold leading-none text-zinc-900 lg:text-6xl">
          {`${numberWithCommas(price.toFixed(2))} `}
          <span className="ml-1 text-4xl lg:text-5xl">{currency}</span>
          <span className="ml-1 text-2xl font-medium leading-8 text-zinc-700">
            /{duration}
          </span>
        </div>
        {partner && partnerPrice !== fullPrice ? (
          <p className="mb-0 mt-2 text-sm leading-normal text-zinc-700">
            {normalPrice}
            <span className="ml-1 line-through">
              {numberWithCommas(fullPrice.toFixed(2))} {currency} /{duration}
            </span>
          </p>
        ) : null}
        {description ? (
          <p className="mb-0 mt-2 text-sm leading-normal text-zinc-600">
            {description} {numberWithCommas((price * 12).toFixed(2))}
            {currency})
          </p>
        ) : null}
      </div>
      <div className="flex grow flex-col justify-end space-y-8 bg-gradient-to-t from-cadetblue-900 to-cadetblue-700 px-6 pb-8 pt-6 sm:p-10 sm:pt-6">
        <ul className="grow">
          {features.map((feature) => (
            <ListItem item={feature} key={kebabCase(feature)} />
          ))}
        </ul>
        <Button
          label={orderModalButton}
          bgStyle="cadetblue"
          onClick={onClick}
          link="#Order"
        />
      </div>
    </div>
  )
}

PricingTier.defaultProps = {
  description: "",
  features: [],
}

PricingTier.propTypes = {
  name: PropTypes.string.isRequired,
  fullPrice: PropTypes.number.isRequired,
  partnerPrice: PropTypes.number.isRequired,
  duration: PropTypes.string.isRequired,
  description: PropTypes.string,
  features: PropTypes.arrayOf(PropTypes.string),
  onClick: PropTypes.func.isRequired,
}

export default PricingTier
